import { FormGroupWrapper } from "@containers/common/form-group-wrapper/form-group-wrapper";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { AXNUITelephoneInput } from "@iddataweb/idw-common-ui/containers";
import { ParsedCountry } from "react-international-phone";
import style from "./international-telephone-form-group.less";


type InternationalTelephoneFormGroupProps = {
    id: string;
    isRequired: boolean;
    label: string;
    labelWidth: LabelWidthTypes;
    phoneNumber: { phone: string; dialCode: string };
    layout?: LayoutTypes;
    className?: string;
    onChange: (phone: string, meta: { country: ParsedCountry; inputValue: string; }) => Promise<void>;
    readOnly?: boolean;
    defaultCountry?: string;
};

export const InternationalTelephoneFormGroup = (props: InternationalTelephoneFormGroupProps) => {
    const { id, phoneNumber, isRequired, label, labelWidth, layout, onChange, className = '', readOnly, defaultCountry = "us" } = props;

    return (
            <FormGroupWrapper
                id={id}
                className={`${style['international-telephone-form-group']} ${className}`}
                label={label}
                isRequired={isRequired}
                layout={layout}
                labelWidth={labelWidth}
            >

                <AXNUITelephoneInput
                    title={""}
                    idPrefix={`${id}-input`}
                    defaultCountry={defaultCountry}
                    disabled={false}
                    isOptional={!isRequired}
                    phoneNumber={phoneNumber}
                    onChange={onChange}
                    onBlur={() => { }}
                    readOnly={readOnly}
                    className={`form-control react-international-phone-input${style['international-telephone-form-group']}`} />
            </FormGroupWrapper>
    );
};